import { render, staticRenderFns } from "./cardElementoExtraviado.vue?vue&type=template&id=6074b1b0&scoped=true"
import script from "./cardElementoExtraviado.vue?vue&type=script&lang=js"
export * from "./cardElementoExtraviado.vue?vue&type=script&lang=js"
import style0 from "./cardElementoExtraviado.vue?vue&type=style&index=0&id=6074b1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6074b1b0",
  null
  
)

export default component.exports